<template>
  <div>
    <Header ref="child" />
    <Navigation :page="page" />

    <!-- ページ1 -->
    <div class="page-three page-style" v-show="page === 1">
      <InputHousehold @handle-change-household="changehouseHold" @handle-change-familylivingtogether="changeFamilyLivingTogether" />
      <NursingPage @handle-change-care-certification="changeCareCertification" @handle-change-care-insurance="changeCareInsurance" />
    </div>

    <!-- ページ2 -->
    <div class="page-four page-style" v-show="page === 2">
      <NursingPage2 @handle-change-medical-insurance="changeMedicalInsurance" @handle-change-handicapped-notebook="changeHandicappedNotebook" @handle-change-rehabilitation-notebook="changeRehabilitationNotebook" @handle-change-mental-notebook="changeMentalNotebook" />
    </div>

    <!-- ページ3 -->
    <div class="page-four page-style" v-show="page === 3">
      <NursingPage3 @handle-change-beneficiary-certificate="changeBeneficiaryCertificate" @handle-change-medical-history="changeMedicalHistory" />
    </div>

    <!-- ページ4 -->
    <div class="page-five" v-show="page === 4">
      <SelectIllustrationPage @handle-change-avatar-id="changeAvatarId" />
    </div>

    <div class="footer">
      <img src="@/assets/sign_up/アセット 4@2x.png" v-if="page > 1" @click="prev" />
      <img src="@/assets/sign_up/アセット 3@2x.png" v-if="page === 1 && this.accountCreate.household_composition === false" class = "inactive_img" />
      <img src="@/assets/sign_up/アセット 3@2x.png" v-else-if="page === 1 && this.accountCreate.household_composition === '1' && this.accountCreate.housemate.length === 0" class = "inactive_img" />
      <img src="@/assets/sign_up/アセット 3@2x.png" v-else-if="page < 4" @click="next" />
      <img src="@/assets/sign_up/アセット 55@2x.png" v-if="page === 4 && this.accountCreate.avatar_id === ''" class = "inactive_img" />
      <img src="@/assets/sign_up/アセット 55@2x.png" v-else-if="page === 4" @click="complete" />
    </div>

    <Dialog v-show="showContent" @pushedCancel="hideContent" @handle-submit="submit" />
  </div>
</template>

<script>
import Header from "@/components/Header";
import Navigation from "@/components/Navigation";
import Dialog from "@/components/ShowDialog";
import InputName from "@/molecules/InputName";
import InputKana from "@/molecules/InputKana";
import InputBirthday from "@/molecules/InputBirthday";
import InputGender from "@/molecules/InputGender";
import InputTelephoneNumber from "@/molecules/InputTelephoneNumber";
import InputAddress from "@/molecules/InputAddress";
import InputHousehold from "@/molecules/InputHousehold";
import NursingPage from "@/templates/NursingPage";
import NursingPage2 from "@/templates/NursingPage2";
import NursingPage3 from "@/templates/NursingPage3";
import SelectIllustrationPage from "@/templates/SelectIllustrationPage";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
const AccountRepository = RepositoryFactory.get("account");
const UserRepository = RepositoryFactory.get("user");

export default {
  name: "AccountCreate",
  components: {
    Header,
    Navigation,
    Dialog,
    InputName,
    InputKana,
    InputBirthday,
    InputGender,
    InputTelephoneNumber,
    InputAddress,
    InputHousehold,
    NursingPage,
    NursingPage2,
    NursingPage3,
    SelectIllustrationPage,
  },
  beforeCreate: function() {
    document.body.className = "user-information";
  },
  data() {
    return {
      page: 1,
      showContent: false,
      isPush: true,
      accountCreate: {
        household_composition: false,
        housemate: [],
        avatar_id: '',
        care_certification: Number,
        care_insurance: Number,
        medical_insurance: Number,
        handicapped_notebook: Number,
        rehabilitation_notebook: Number,
        mental_notebook: Number,
        beneficiary_certificate: Number,
        medical_history: [],
      },
    };
  },
  created() {
    // アクセストークンが有効期限きれかどうか判定する
    this.RefreshTokenUpdate()
  },
  methods: {
    async RefreshTokenUpdate(){
      this.$store.state.axiosHeaders.access_token_expires_in = 1614566933; //有効期限切れトークン　検証時にコメントアウト外す
      // users.access_token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJsYXNoaWMiLCJleHAiOjE2NDA4NzY0MDAsInVzZXJfaWQiOiI3Nzc3In0.vzDNjvjXiM8f41xSU48-zI7VYEPXPbOpVlENvuHaWgg"
      let access_token_expires_in = new Date(this.$store.state.axiosHeaders.access_token_expires_in * 1000);
      let now = new Date();

      if (now > access_token_expires_in) {
        const UserEndpoint = "token/refresh";
        const body = {
          refresh_token: this.$store.state.axiosHeaders.refresh_token,
        };
        const config = {
          withCredentials: true,
        };
        await UserRepository.put(UserEndpoint, body, {config})
        .then(response => (this.res = response.data))
        .catch((error) => console.log(error))
        .finally(() => {
          const headers = {
            Authorization: "Bearer " + this.res.access_token,
            "Ocp-Apim-Subscription-Key": process.env.SUBSCRIPTION_KEY,
            access_token_expires_in: this.res.access_token_expires_in,
            refresh_token: this.res.refresh_token
            }
            this.$store.commit("FETCH_ADD_AXIOS_HEADERS", headers);
        })
      }
    },
    changehouseHold(val) {
      this.accountCreate.household_composition = val;
    },
    changeFamilyLivingTogether(val) {
      this.accountCreate.housemate = val;
    },
    changeCareCertification(val) {
      this.accountCreate.care_certification = val;
    },
    changeCareInsurance(val) {
      this.accountCreate.care_insurance = val;
    },
    changeMedicalInsurance(val) {
      this.accountCreate.medical_insurance = val;
    },
    changeHandicappedNotebook(val) {
      this.accountCreate.handicapped_notebook = val;
    },
    changeRehabilitationNotebook(val) {
      this.accountCreate.rehabilitation_notebook = val;
    },
    changeMentalNotebook(val) {
      this.accountCreate.mental_notebook = val;
    },
    changeBeneficiaryCertificate(val) {
      this.accountCreate.beneficiary_certificate = val;
    },
    changeMedicalHistory(val) {
      this.accountCreate.medical_history = val;
    },
    changeAvatarId(val) {
      this.accountCreate.avatar_id = val;
    },
    // 次に進むボタン押下時処理
    next() {
      this.page++;
    },
    // 前に戻るボタン押下時処理
    prev() {
      this.page--;
    },
    async submit() {
      this.$store.commit("FETCH_SET_TUTORIAL", true)
      const response = await AccountRepository.post(this.accountCreate, this.$store.state.axiosHeaders)
        .then((response) => (console.log(response.data)))
        .catch(error => console.log(error))
        .finally(() => this.$router.push("/home"));
    },
    navigationCss(targetPage) {
      if (this.page === targetPage) {
        // 現在ページの場合
        return ["col-4", "text-center", "text-white", "bg-info"];
      }
      return ["col-4", "text-center", "text-secondary"];
    },
    complete() {
      this.showContent = true;
    },
    hideContent() {
      this.showContent = false;
    },
  },
};
</script>

<style scoped>
body.user-information {
  background-color: white;
}
.page-style {
  text-align: left;
  padding: 0px 25px;
}
.required {
  color: white;
  margin-left: 10px;
  font-size: 1rem;
  font-weight: bold;
  background-color: red;
  padding: 0 10px;
  border-radius: 5px;
}
.text-white {
  color: #fff !important;
}
.text-center {
  text-align: center !important;
}
.bg-info {
  background-color: #00a0b9 !important;
}
.under-line-width {
  width: 300px;
}
.item-name {
  display: flex;
  margin-bottom: 5px;
}
.footer {
  position: absolute;
  bottom: 5%;
}
.inactive_img{
    opacity: .20;
  }
</style>



// WEBPACK FOOTER //
// src/pages/AccountCreate.vue